export enum Company {
  UN1QUELY = "UN1QUELY",
  BRIGHTLY = "Brightly",
  BRIGHT_MARBLES = "BrightMarbles",
  BRIGHT_MARBLES_NETHERLANDS = "BrightMarbles Netherlands",
  BRIGHT_MARBLES_MACEDONIA = "BrightMarbles Macedonia",
}
